export const Gutenberg = [
    {
        "DataControls": {
            "Name": "Data Controls",
            "data": [
                {
                    "name": "text",
                    'label': "Text",
                    'icon': "text",
                    'keyword': ["text"]
                },
                {
                    "name": "number",
                    "label": "Number",
                    "icon": "number",
                    "keyword": ["number"]
                },
                {
                    "name": "textarea",
                    "label": "Textarea",
                    "icon": "textarea",
                    "keyword": ["textarea"]
                },
                {
                    "name": "switcher",
                    "label": "Toggle",
                    "icon": "switcher",
                    "keyword": ["toggle", "switcher", "checkbox"]
                },
                {
                    "name": "popover",
                    "label": "GroupPopover",
                    "icon": "popover",
                    "keyword": ["grouppopover", "popover", "popup"]
                },
                {
                    "name": "select",
                    "label": "Select",
                    "icon": "select",
                    "keyword": ["select", "dropdown"]
                },
                {
                    "name": "select2",
                    "label": "Select2",
                    "icon": "select2",
                    "keyword": ["select2", "multiselect", "multidropdown"]
                },
                {
                    "name": "choose",
                    "label": "RadioAdvanced",
                    "icon": "choose",
                    "keyword": ["choose", "radioadvanced", "align", "justify"]
                },
                {
                    "name": "color",
                    "label": "Color",
                    "icon": "color",
                    "keyword": ["color"]
                },
                {
                    "name": "gradientcolor",
                    "label": "GradientColor",
                    "icon": "gradientcolor",
                    "keyword": ["gradientcolor"]
                },
                {
                    "name": "datetime",
                    "label": "DateTime",
                    "icon": "datetime",
                    "keyword": ["datetime", "time"]
                },
                {
                    "name": "gallery",
                    "label": "Gallery",
                    "icon": "gallery",
                    "keyword": ["gallery", "image", "multimedia"]
                },
                {
                    "name": "repeater",
                    "label": "Repeater",
                    "icon": "repeater",
                    "keyword": ["repeater"]
                }
            ]
        },
        "Multivalue Controls": {
            "Name": "Multivalue Controls",
            "data": [
                {
                    "name": "url",
                    "label": "URL",
                    "icon": "url",
                    "keyword": ["url", "link"]
                },
                {
                    "name": "media",
                    "label": "Media",
                    "icon": "media",
                    "keyword": ["media", "image"]
                },
                {
                    "name": "iconscontrol",
                    "label": "IconsControl",
                    "icon": "iconscontrol",
                    "keyword": ["icon", "fontawesome", "iconscontrol"]
                },
                {
                    "name": "headingtags",
                    "label": "HeadingTags",
                    "icon": "headingtags",
                    "keyword": ["headingtags",]
                }
            ]
        },
        "Unit Controls": {
            "Name": "Unit Controls",
            "data": [
                {
                    "name": "slider",
                    "label": "Slider",
                    "icon": "slider",
                    "keyword": ["slider", "range"]
                },
                {
                    "name": "dimension",
                    "label": "Dimension",
                    "icon": "dimension",
                    "keyword": ["padding", "margin", "dimension"]
                },
                {
                    "name": "normalhover",
                    "label": "NormalHover",
                    "icon": "normalhover",
                    "keyword": ["hover", "normalhover"]
                }
            ]
        },
        "UI Controls": {
            "Name": "UI Controls",
            "data": [
                {
                    "name": "heading",
                    "label": "Heading",
                    "icon": "heading",
                    "keyword": ["heading", "info", "note", "labelheading"]
                },
                {
                    "name": "rawhtml",
                    "label": "RawHTML",
                    "icon": "rawhtml",
                    "keyword": ["rawhtml", "info", "note"]
                }
            ]
        },
        "Group Controls": {
            "Name": "Group Controls",
            "data": [
                {
                    "name": "typography",
                    "label": "Typography",
                    "icon": "typography",
                    "keyword": ["typography"],
                },
                {
                    "name": "textshadow",
                    "label": "TextShadow",
                    "icon": "textshadow",
                    "keyword": ["textshadow", "shadow"]
                },
                {
                    "name": "boxshadow",
                    "label": "BoxShadow",
                    "icon": "boxshadow",
                    "keyword": ["boxshadow", "shadow"]
                },
                {
                    "name": "border",
                    "label": "Border",
                    "icon": "border",
                    "keyword": ["border"]
                },
                {
                    "name": "background",
                    "label": "Background",
                    "icon": "background",
                    "keyword": ["background"]
                },
                {
                    "name": "cssfilter",
                    "label": "CssFilter",
                    "icon": "cssfilter",
                    "keyword": ["cssfilter", "filtercss"]
                }
            ]
        },
    },
];

export const Elementor = [
    {
        "DataControls": {
            "Name": "Data Controls",
            "data": [
                {
                    "name": "text",
                    "label": "Text",
                    "icon": "text",
                    "keyword": ["text"]
                },
                {
                    "name": "number",
                    "label": "Number",
                    "icon": "number",
                    "keyword": ["number"]
                },
                {
                    "name": "textarea",
                    "label": "Textarea",
                    "icon": "textarea",
                    "keyword": ["textarea"]
                },
                {
                    "name": "wysiwyg",
                    "label": "WYSIWYG",
                    "icon": "wysiwyg",
                    "keyword": ["textarea", "wysiwyg"]
                },
                {
                    "name": "switcher",
                    "label": "Switcher",
                    "icon": "switcher",
                    "keyword": ["toggle", "switcher", "checkbox"]
                },
                {
                    "name": "popover",
                    "label": "Popover",
                    "icon": "popover",
                    "keyword": ["grouppopover", "popover", "popup"]
                },
                {
                    "name": "select",
                    "label": "Select",
                    "icon": "select",
                    "keyword": ["select", "dropdown"]
                },
                {
                    "name": "select2",
                    "label": "Select2",
                    "icon": "select2",
                    "keyword": ["select2", "multiselect", "multidropdown"]
                },
                {
                    "name": "choose",
                    "label": "Choose",
                    "icon": "choose",
                    "keyword": ["choose", "radioadvanced", "align", "justify"]
                },
                {
                    "name": "color",
                    "label": "Color",
                    "icon": "color",
                    "keyword": ["color"]
                },
                {
                    "name": "datetime",
                    "label": "DateTime",
                    "icon": "datetime",
                    "keyword": ["datetime", "time"]
                },
                {
                    "name": "gallery",
                    "label": "Gallery",
                    "icon": "gallery",
                    "keyword": ["gallery", "image", "multimedia"]
                },
                {
                    "name": "repeater",
                    "label": "Repeater",
                    "icon": "repeater",
                    "keyword": ["repeater"]
                }
            ]
        },
        "WDesignKitControls": {
            "Name": "WDsignKit Controls",
            "data": [
                {
                    "name": "selecttemplate",
                    "label": "SelectTemplate",
                    "icon": "selecttemplate",
                    "keyword": ["selecttemplate", "query"]
                },
            ]
        },
        "Multivalue Controls": {
            "Name": "Multivalue Controls",
            "data": [
                {
                    "name": "url",
                    "label": "URL",
                    "icon": "url",
                    "keyword": ["url", "link"]
                },
                {
                    "name": "media",
                    "label": "Media",
                    "icon": "media",
                    "keyword": ["media", "image"]
                },
                {
                    "name": "iconscontrol",
                    "label": "IconsControl",
                    "icon": "iconscontrol",
                    "keyword": ["icon", "fontawesome", "iconscontrol"]
                },
                {
                    "name": "headingtags",
                    "label": "HeadingTags",
                    "icon": "headingtags",
                    "keyword": ["headingtags",]
                }
            ]
        },
        "Unit Controls": {
            "Name": "Unit Controls",
            "data": [
                {
                    "name": "slider",
                    "label": "Slider",
                    "icon": "slider",
                    "keyword": ["slider", "range"]
                },
                {
                    "name": "dimension",
                    "label": "Dimension",
                    "icon": "dimension",
                    "keyword": ["padding", "margin", "dimension"]
                },
                {
                    "name": "normalhover",
                    "label": "NormalHover",
                    "icon": "normalhover",
                    "keyword": ["hover", "normalhover"]
                }
            ]
        },
        "UI Controls": {
            "Name": "UI Controls",
            "data": [
                {
                    "name": "heading",
                    "label": "Heading",
                    "icon": "heading",
                    "keyword": ["heading", "info", "note", "labelheading"]
                },
                {
                    "name": "rawhtml",
                    "label": "RawHTML",
                    "icon": "rawhtml",
                    "keyword": ["rawhtml", "info", "note"]
                },
                {
                    "name": "divider",
                    "label": "Divider",
                    "icon": "divider",
                    "keyword": ["divider", "separator"]
                }
            ]
        },
        "Group Controls": {
            "Name": "Group Controls",
            "data": [
                {
                    "name": "typography",
                    "label": "Typography",
                    "icon": "typography",
                    "keyword": ["typography"]
                },
                {
                    "name": "textshadow",
                    "label": "TextShadow",
                    "icon": "textshadow",
                    "keyword": ["textshadow", "shadow"]
                },
                {
                    "name": "boxshadow",
                    "label": "BoxShadow",
                    "icon": "boxshadow",
                    "keyword": ["boxshadow", "shadow"]
                },
                {
                    "name": "border",
                    "label": "Border",
                    "icon": "border",
                    "keyword": ["border"]
                },
                {
                    "name": "background",
                    "label": "Background",
                    "icon": "background",
                    "keyword": ["background"]
                },
                {
                    "name": "cssfilter",
                    "label": "CssFilter",
                    "icon": "cssfilter",
                    "keyword": ["cssfilter", "filtercss"]
                }
            ]
        }
    }
];

export const Bricks = [
    {
        "DataControls": {
            "Name": "Data Controls",
            "data": [
                {
                    "name": "text",
                    "label": "Text",
                    "icon": "text",
                    "keyword": ["text"]
                },
                {
                    "name": "number",
                    "label": "Number",
                    "icon": "number",
                    "keyword": ["number"]
                },
                {
                    "name": "textarea",
                    "label": "Textarea",
                    "icon": "textarea",
                    "keyword": ["textarea", "wysiwyg"]
                },
                {
                    "name": "wysiwyg",
                    "label": "WYSIWYG",
                    "icon": "wysiwyg",
                    "keyword": ["wysiwyg", "editor"]
                },
                {
                    "name": "switcher",
                    "label": "Checkbox",
                    "icon": "switcher",
                    "keyword": ["toggle", "switcher", "checkbox"]
                },
                {
                    "name": "select",
                    "label": "DropDown",
                    "icon": "select",
                    "keyword": ["select", "dropdown"]
                },
                {
                    "name": "select2",
                    "label": "MultiSelect",
                    "icon": "select2",
                    "keyword": ["select2", "multiselect", "multidropdown"]
                },
                {
                    "name": "align",
                    "label": "Align",
                    "icon": "choose",
                    "keyword": ["align", "choose"]
                },
                {
                    "name": "color",
                    "label": "Color",
                    "icon": "color",
                    "keyword": ["color"]
                },
                {
                    "name": "gradientcolor",
                    "label": "GradientColor",
                    "icon": "gradientcolor",
                    "keyword": ["gradientcolor"]
                },
                {
                    "name": "datetime",
                    "label": "DateTime",
                    "icon": "datetime",
                    "keyword": ["datetime", "time"]
                },
                {
                    "name": "gallery",
                    "label": "Gallery",
                    "icon": "gallery",
                    "keyword": ["gallery", "image", "multimedia"]
                },
                {
                    "name": "repeater",
                    "label": "Repeater",
                    "icon": "repeater",
                    "keyword": ["repeater"]
                },
            ]
        },
        "Multivalue Controls": {
            "Name": "Multivalue Controls",
            "data": [
                {
                    "name": "url",
                    "label": "URL",
                    "icon": "url",
                    "keyword": ["url", "link"]
                },
                {
                    "name": "media",
                    "label": "Media",
                    "icon": "media",
                    "keyword": ["media", "image"]
                },
                {
                    "name": "iconscontrol",
                    "label": "Icon",
                    "icon": "iconscontrol",
                    "keyword": ["icon", "fontawesome", "iconscontrol"]
                },
                {
                    "name": "headingtags",
                    "label": "HeadingTags",
                    "icon": "headingtags",
                    "keyword": ["headingtags",]
                }
            ]
        },
        "Unit Controls": {
            "Name": "Unit Controls",
            "data": [
                {
                    "name": "slider",
                    "label": "Slider",
                    "icon": "slider",
                    "keyword": ["slider", "range"]
                },
                {
                    "name": "dimension",
                    "label": "Dimension",
                    "icon": "dimension",
                    "keyword": ["padding", "margin", "dimension"]
                },
            ]
        },
        "UI Controls": {
            "Name": "UI Controls",
            "data": [
                {
                    "name": "heading",
                    "label": "Info",
                    "icon": "heading",
                    "keyword": ["heading", "info", "note", "labelheading"]
                },
                {
                    "name": "divider",
                    "label": "Divider",
                    "icon": "divider",
                    "keyword": ["divider", "separator"]
                }
            ]
        },
        "Group Controls": {
            "Name": "Group Controls",
            "data": [
                {
                    "name": "typography",
                    "label": "Typography",
                    "icon": "typography",
                    "keyword": ["typography"]
                },
                {
                    "name": "textshadow",
                    "label": "TextShadow",
                    "icon": "textshadow",
                    "keyword": ["textshadow", "shadow"]
                },
                {
                    "name": "boxshadow",
                    "label": "BoxShadow",
                    "icon": "boxshadow",
                    "keyword": ["boxshadow", "shadow"]
                },
                {
                    "name": "border",
                    "label": "Border",
                    "icon": "border",
                    "keyword": ["border"]
                },
                {
                    "name": "background",
                    "label": "background",
                    "icon": "Background",
                    "keyword": ["background"]
                },
                {
                    "name": "cssfilter",
                    "label": "CssFilter",
                    "icon": "cssfilter",
                    "keyword": ["cssfilter", "filtercss"]
                }
            ]
        }
    }
];